import { useState } from 'react';
import { RegionErrorBoundary } from '../shell/RegionErrorBoundary.js';
import { Page, PageHead } from '../ui/index.js';
import { FellowPanel } from './fellow-panel.js';
import { SlackPanel } from './slack-panel.js';
import './pages.css';

// The Connections page (spec §13; owner ruling 20260926-002133): one panel per integration, each
// loading, failing and rendering its own states inside its own titled section, so one that cannot
// load never takes the other with it. The page keeps one primary action (03-components §2): the
// first "Connect …" offer in document order — Fellow's when it offers one, else Slack's — or none
// when everything is connected.

export default function ConnectionsPage() {
  const [fellowOffersConnect, setFellowOffersConnect] = useState<boolean | null>(null);
  return (
    <Page measure="reading">
      <PageHead title="Connections" />
      <RegionErrorBoundary region="the Fellow connection" compact>
        <FellowPanel onConnectOffered={setFellowOffersConnect} />
      </RegionErrorBoundary>
      <RegionErrorBoundary region="the Slack connection" compact>
        <SlackPanel connectIsPrimary={fellowOffersConnect === false} />
      </RegionErrorBoundary>
    </Page>
  );
}
